import { useEffect, useState } from 'react';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { Pagination } from '../../../Components/Custom/pagination';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { paramsForExport, setDocumentTitle } from '../../../helpers/helpers';
import { columns } from './columns';
import { Filters } from './filters';
import {
  getLicenses,
  exportLicences,
  exportHeaders,
  removeLicencesForExport
} from './slice';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import { getUserFromLS } from '../../../helpers/localstorage-helper';
import { CreateLicenceModal } from './createLicence';

const PAGE_TITLE = 'Licenses';

const INITIAL_PARAMS: {
  sortBy: string;
  sortOrder: string;
  countPerPage: string;
  numberOfPage: string;
} = {
  sortBy: 'dateCreated',
  sortOrder: 'DESC',
  countPerPage: '10',
  numberOfPage: '1'
};

const LicensesPage = () => {
  const dispatch = useAppDispatch();
  const user = getUserFromLS();

  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);

  const [createLicenceModal, setCreateLicenceModal] = useState(false);
  const [id, setId] = useState<any>();
  const [product, setProduct] = useState<any>();

  const { loading, data, totalCount, dataForExport, loadingExport } =
    useAppSelector((state) => state.licenses);

  useEffect(() => {
    dispatch(getLicenses(searchParams));
  }, [searchParams]);

  setDocumentTitle(PAGE_TITLE);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Dashboard' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading}
                title={PAGE_TITLE}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                actions={
                  <>
                    {user?.permissions?.superAdmin && (
                      <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => {
                          setCreateLicenceModal(!createLicenceModal);
                          setId('');
                          setProduct('');
                        }}>
                        Create Licence
                      </button>
                    )}

                    <CsvExport
                      action={() =>
                        dispatch(exportLicences(paramsForExport(searchParams)))
                      }
                      data={dataForExport}
                      headers={exportHeaders}
                      disabled={loadingExport}
                      fileName={`licences-${moment().format('DD-MM-YYYY')}`}
                      removeDataAction={removeLicencesForExport}
                    />
                  </>
                }
              />
              <CardBody className='pt-0'>
                <Filters params={searchParams} setParams={setSearchParams} />

                <TableContainer
                  columns={columns || []}
                  data={data}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <CreateLicenceModal
        isOpen={createLicenceModal}
        setIsOpen={setCreateLicenceModal}
        setProduct={setProduct}
        product={product}
        setId={setId}
        id={id}
        params={searchParams}
      />
    </div>
  );
};

export default LicensesPage;
